import request from '@/axios';
import { getTime } from '@/utils/util';

export const getImageList = params => request({
  url: '/emp-business/photos/list',
  method: 'get',
  params
})

export const addImage = data => request({
  url: '/emp-business/photos/save',
  method: 'post',
  data
})

export const removeImage = data => request({
  url: '/emp-business/photos/remove',
  method: 'post',
  params: data
})

// 网关设备树的列表
export const getTreeList = (current, size, params) => {
  return request({
    url: '/emp-data-center/emp-data/device/treelist',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};
// 四遥类型
export const getFourRemoteTypes = params => axios({
  url: '/blade-system/dict/dictionary?code=typesOfTelemetering',
  method: 'get',
  params
})

// 获取测量点数据列表
export const getPointList = (params) => {
  return request({
    url: '/emp-data-center/emp-data/deviceItem/list',
    method: 'get',
    params
  })
}

// 据数据项id获取实时数据
export const getRtDataByItemIds = ids => request({
  // url: '/api/ml-mlink/itemrd/getRtDataByItemIds',
  url: '/emp-data-center/emp-data/deviceItem/list',
  method: 'get',
  params: {id: ids[0]}
})

// 获取历史数据
export const getHistoryData = data => {
  const times = getTime(data.dataType, data.time);
  return request({
    url: '/emp-data-center/historydata/getHistoryData',
    method: 'post',
    data: {
      items: data.items,
      dataType: data.dataType || '5',
      compareType: data.compareType || '0',
      ...times,
    }
  })
}


// 时间类型类型
export const getTimeTypes = params => axios({
  url: '/blade-system/dict/dictionary?code=dataType',
  method: 'get',
  params
})

// 同环比类型
export const getCompareTypes = params => axios({
  url: '/blade-system/dict/dictionary?code=compareType',
  method: 'get',
  params
})